import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/WhiskeyRebel2.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import { trackServiceInquiry } from '../lib/analytics';
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const CALENDLY_URL = 'https://calendly.com/george-hoffmann-whiskeyrebel/discovery-call-30-minutes';

export const Banner = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  const handleBookClick = () => {
    trackServiceInquiry('banner_book_strategy_session');
  };

  return (
    <section className="banner" id="home" aria-label="Hero section">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility once>
              {({ isVisible }) =>
              <div className={prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}>
                <span className="tagline">Where Rebel Brands Scale Faster.</span>
                <h1>Built to Disrupt. Designed to Grow.</h1>
                <p className="intro">
                  Whiskey Rebel Creative helps startups, local businesses, and performance-driven brands accelerate growth through strategic branding, modern web design, and AI-powered marketing.
                </p>
                <p className="intro">
                  Human creativity meets AI intelligence to build bold brands, scalable systems, and measurable results.
                </p>
                <a
                  href={CALENDLY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleBookClick}
                  className="cta-button"
                >
                  Book a Free Strategy Session <ArrowRightCircle size={25} aria-hidden="true" />
                  <span className="visually-hidden"> (opens in new tab)</span>
                </a>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <div className={!prefersReducedMotion ? "banner-hero-img animate__animated animate__zoomIn" : "banner-hero-img"}>
              <img
                src={headerImg}
                alt="Whiskey Rebel Creative hero illustration - stylized graphic representing digital creativity and innovation"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
